export const translations = {
  'This could also be of interest to you': {
    de_DE: 'Das könnte dich auch interessieren'
  },
  'Find out more': {
    de_DE: 'Mehr entdecken'
  }
};
